import { useEffect, useState } from 'react';

const WHATSAPP_URL = 'https://wa.me/5511986765185?text=Ol%C3%A1!%20Vim%20pelo%20site%20e%20gostaria%20de%20um%20or%C3%A7amento%20para%20fechamento%20de%20sacada.';

export default function HeroSection() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="relative min-h-[90vh] flex items-center overflow-hidden">
      {/* Background */}
      <img
        src="https://readdy.ai/api/search-image?query=luxury%20modern%20apartment%20balcony%20with%20frameless%20articulated%20glass%20enclosure%20sliding%20panels%20open%20view%20to%20S%C3%A3o%20Paulo%20city%20skyline%20high%20end%20residential%20architecture%20premium%20finish%20natural%20sunlight%20warm%20golden%20hour%20lighting%20clean%20minimal%20design&width=1920&height=1080&seq=lp-hero-sacada-01&orientation=landscape"
        alt="Envidraçamento de sacada articulada de alto padrão em São Paulo"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/55 to-black/80"></div>

      {/* Floating WhatsApp Button */}
      <div className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${scrolled ? 'bg-stone-900/95 backdrop-blur-sm shadow-lg' : 'bg-transparent'}`}>
        <div className="max-w-5xl mx-auto px-4 md:px-6 flex items-center justify-between h-14 md:h-16">
          <img
            src="https://static.readdy.ai/image/b82e091d2ee2b446e9b53ab9857e20be/1bea56054998f72dc157944f3d260472.png"
            alt="Vidros Thelux"
            className="h-9 md:h-11 object-contain"
          />
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-bold px-4 py-2 rounded-full text-xs md:text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-whatsapp-line text-base"></i>
            </div>
            <span className="hidden sm:inline">Orçamento Grátis</span>
            <span className="sm:hidden">WhatsApp</span>
          </a>
        </div>
      </div>

      {/* Hero Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-4 md:px-6 pt-20 pb-12">
        <div className="max-w-2xl">
          <span className="inline-block text-xs font-semibold tracking-widest text-amber-400 uppercase mb-4 border border-amber-400/40 px-3 py-1 rounded-full">
            Envidraçamento de Sacada — São Paulo
          </span>

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-3">
            Fechamento de Sacada Articulada Sem Roldana.
            <span className="block text-amber-400">Instalação Premium em São Paulo.</span>
          </h1>

          <p className="text-sm md:text-base text-white/80 mb-2 font-light max-w-lg">
            O sistema articulado mais moderno do mercado — movimento suave, silencioso e design que valoriza seu imóvel.
          </p>

          <ul className="flex flex-wrap gap-x-5 gap-y-1.5 mb-8">
            {[
              'Sem roldanas — zero desgaste',
              'Vidro temperado certificado',
              'Conforme NBR 7199',
              'Garantia de fábrica',
            ].map((item) => (
              <li key={item} className="flex items-center gap-1.5 text-white/70 text-xs">
                <div className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-check-line text-green-400 text-xs"></i>
                </div>
                {item}
              </li>
            ))}
          </ul>

          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white font-bold px-8 py-4 rounded-full text-base md:text-lg transition-all duration-200 whitespace-nowrap hover:scale-105 cursor-pointer shadow-lg shadow-green-500/30"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-whatsapp-line text-xl"></i>
            </div>
            QUERO MEU ORÇAMENTO GRÁTIS
          </a>

          <a
            href="/#galeria-videos"
            className="inline-flex items-center gap-2 mt-5 text-amber-400 hover:text-amber-300 font-semibold text-sm md:text-base transition-all duration-200 whitespace-nowrap cursor-pointer group"
          >
            Veja Nossas Instalações em Vídeo
            <div className="w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform duration-200">
              <i className="ri-arrow-right-line text-base"></i>
            </div>
          </a>

          <p className="text-white/50 text-xs mt-4">
            Resposta em até 15 minutos em horário comercial
          </p>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 text-white/40 animate-bounce">
        <div className="w-4 h-4 flex items-center justify-center">
          <i className="ri-arrow-down-line text-lg"></i>
        </div>
        <span className="text-[10px] tracking-widest uppercase">Role</span>
      </div>
    </section>
  );
}